module.exports = __webpack_public_path__ + "static/media/decrement-arrow.a85cfc21.png";